import React from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { getMaintenanceMode } from 'uniba-volto-manutenzione/actions';
import { logout, purgeMessages } from '@plone/volto/actions';
import { useDispatch, useSelector } from 'react-redux';

function ManutenzioneViewlet({ toastify }) {
    const dispatch = useDispatch();
    const maintenanceMode = useSelector(state => state.maintenanceMode?.result);

    const LOGOUT_KEY = 'maintenance_logout_at';
    const TOAST_ID = 'maintenance_toast';

    const countdownInterval = React.useRef(null);
    const hasLoggedOutRef = React.useRef(false);

    const logout_timer = 120000;
    const update_timer = 10000;

    const doLogout = () => {
        dispatch(logout());
        dispatch(purgeMessages());
    };

    React.useEffect(() => {
        let isMounted = true;
        const intervalId = setInterval(() => {
            if (isMounted) {
                dispatch(getMaintenanceMode());
            }
        }, update_timer);

        return () => {
            isMounted = false;
            clearInterval(intervalId);
        };
    }, [dispatch]);

    React.useEffect(() => {
        if (maintenanceMode?.maintenance_mode !== true) {
            if (countdownInterval.current) {
                clearInterval(countdownInterval.current);
                countdownInterval.current = null;
            }
            return;
        }

        if (countdownInterval.current) {
            return;
        }

        let logoutAt = parseInt(localStorage.getItem(LOGOUT_KEY) || (Date.now() + logout_timer), 10)
        localStorage.setItem(LOGOUT_KEY, logoutAt);

        const updateCountdown = () => {
            const remaining = logoutAt - Date.now();

            if (remaining <= 0) {
                if (!hasLoggedOutRef.current) {
                    hasLoggedOutRef.current = true;
                    localStorage.removeItem(LOGOUT_KEY);
                    toastify.toast.dismiss(TOAST_ID);
                    doLogout();
                }
                clearInterval(countdownInterval.current);
                countdownInterval.current = null;
                return;
            }

            const totalSeconds = Math.ceil(remaining / 1000);
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;

            const formatted = `${minutes}:${seconds.toString().padStart(2, '0')}`;

            const message = (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div>{maintenanceMode?.maintenance_message}</div>
                    <div
                        style={{
                            alignSelf: 'center',
                            border: '3px solid #d32f2f',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#d32f2f',
                            backgroundColor: '#fff5f5',
                        }}
                        className='px-3'
                    >
                        Logout tra {formatted}
                    </div>
                </div>
            );

            if (!toastify.toast.isActive(TOAST_ID)) {
                toastify.toast.error(message, { autoClose: false, toastId: TOAST_ID });
            } else {
                toastify.toast.update(TOAST_ID, { render: message });
            }
        };

        updateCountdown();
        countdownInterval.current = setInterval(updateCountdown, 500);

        return () => {
            if (countdownInterval.current) {
                clearInterval(countdownInterval.current);
                countdownInterval.current = null;
            }
        };

    }, [maintenanceMode])

    return null;
};

export default injectLazyLibs(['toastify'])(ManutenzioneViewlet);